module.exports = __webpack_public_path__ + "img/schale_1_a.c4adcd43.jpg";